/**
 * 与后端 org.mitu.constants.ErrorCode 保持一致。
 */
const ERROR_CODE = {
  1: "系统异常，请联系管理员！",
  2: "用户名或密码无效.",
  3: "账号已锁定，请稍后再试",
  4: "验证码错误，请重新登录",
  5: "登录已失效，请重新登录",
  6: "未登录",
  7: "无权限",
  8: "参数不完整",
  9: "验证码错误",
  10: "验证码发送失败",
  11: "用户不存在或已被删除",
  12: "旧密码不正确",
  13: "密码不符合安全策略",
  14: "密码修改失败",
  15: "密保问题答案不正确",
  16: "该账号未配置密保，请使用其他找回方式！",
  17: "非法请求",
  18: "验证已失效，请重新验证",
  19: "已绑定其他账户",
  20: "文件大小超出限制, 请压缩或降低文件质量! ",
  21: "操作失败",
  22: "账号信息不匹配",
  23: "校验失败",
  24: "账号校验失败",
  25: "新密码不能与旧密码相同",
  26: "旧密码不能为空",
  27: "两次输入的新密码不一致",
};

export function loginErrorText(code, message) {
  if (ERROR_CODE[code]) {
    return ERROR_CODE[code];
  }
  return message || ERROR_CODE[1];
}

export function errorCodeText(code, message) {
  return loginErrorText(code, message);
}
